import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll to top whenever the route changes. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};
